export default (state = {}, action) => {
  switch( action.type ) {
    case 'ARTIST_ADDED':
      return {
        ...state,
        artists: action.artists
      };
    case 'ARTIST_PAGE_LOADED':
      return {
        ...state,
        artist: action.artist
      };
    case 'ARTIST_PAGE_UNLOADED':
      return {
        ...state,
        artist: {}
      };
    case 'INFINITE_LOAD':
      return {
        ...state,
        currArtists: action.payload
      };
    case 'MEDIUM_CLICK':
      return {
        ...state,
        currArtists: []
      };
    case 'SEARCH_CHANGE':
      return {
        ...state,
        search: action.payload
      };
    default:
      return state;
  }

  return state;
};



// WEBPACK FOOTER //
// ./src/reducers/artists.js